import React from "react";
import cn from "./helpers/cn";

export const TableVariantContext = React.createContext<"head" | "body" | "footer">("body");

interface TableHeadProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  component?: React.ElementType;
  children?: React.ReactNode;
}

const TableHead = React.forwardRef<HTMLTableSectionElement, TableHeadProps>((props, ref) => {
  const { className, component: Component = "thead", children, ...other } = props;

  return (
    <TableVariantContext.Provider value="head">
      <Component ref={ref} className={cn(className)} {...other}>
        {children}
      </Component>
    </TableVariantContext.Provider>
  );
});

TableHead.displayName = "TableHead";

export default TableHead;
